import * as Yup from 'yup';
import validator from 'validator';
import i18next from 'i18next';
import {combineDateTime} from '../library/dates';
import {DEFAULT_TIME_ZONE} from '../globalVariables/locals';
import store from '../store';

export default function yupMethods(){
    Yup.addMethod(Yup.mixed, 'decimal', function(message) {
        return this.test('decimal', message, function(value) {
            return !value || (value && validator.isDecimal(value));
        });
    });
    Yup.addMethod(Yup.mixed, 'minLength', function(min, message) {
        return this.test('minLength', message, function(value) {
            if(value?.length<min)
                return false;
            return true;
        });
    });
}

export const yupStringMin = (min = 2, message = i18next.t('global:errorCharacters')) => {
    return Yup.string().min(min, message).matches(/(\S.*\S)/,  i18next.t('global:InvalidTemplate'));
};

// Generic helper function to validate that one date/time is after another
export const createDateAfterValidator = (
    testName,
    errorMessage,
    beforeDateRef,
    beforeTimeRef,
    afterDateRef,
    afterTimeRef
) => {
    return Yup.number().test(testName, errorMessage, function(value) {
        if(!value) {
            return true;
        }
        const getFieldValue = (fieldRef) => {
            if(fieldRef === null) {
                return value;
            }
            return this.resolve(Yup.ref(fieldRef));
        };
        
        const beforeDate = getFieldValue(beforeDateRef);
        const beforeTime = getFieldValue(beforeTimeRef);
        const afterDate = getFieldValue(afterDateRef);
        const afterTime = getFieldValue(afterTimeRef);
        
        if(!beforeDate || !afterDate) {
            return true;
        }
        
        const beforeDateTime = combineDateTime(beforeDate, beforeTime || 0, DEFAULT_TIME_ZONE);
        const afterDateTime = combineDateTime(afterDate, afterTime || 0, DEFAULT_TIME_ZONE);
        
        return afterDateTime > beforeDateTime;
    });
};

export const createEventDateRangeValidator = (
    dateFieldRef,
    timeFieldRef,
    errorAfterEndMessage,
    errorBeforeStartMessage
) => {
    return Yup.number().test('eventDateRange', '', function(value) {
        const isDateField = this.path === dateFieldRef;
        const isTimeField = this.path === timeFieldRef;

        if(!isDateField && !isTimeField) {
            return true;
        }

        const date = isDateField ? value : this.resolve(Yup.ref(dateFieldRef));
        const time = isTimeField ? value : this.resolve(Yup.ref(timeFieldRef));

        if(!date) {
            return true;
        }

        const event = store.getState().event;
        const timeZone = event?.timeZone || DEFAULT_TIME_ZONE;
        const dateTime = combineDateTime(date, time || date, timeZone);

        if(event?.timeEnd && dateTime > event.timeEnd) {
            return this.createError({message: errorAfterEndMessage});
        }
        if(event?.timeStart && dateTime < event.timeStart) {
            return this.createError({message: errorBeforeStartMessage});
        }
        return true;
    });
};
